// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3nDlV","title":"Header_title__1f17P","left":"Header_left__3ZaWm","clinicName":"Header_clinicName__xWKIX"};